import "./App.css";
import "./EntryText.css";
import { useState, useRef, useEffect } from "react";
import arrow from "./photos/arrow.svg";

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

import PaymentDrawer from "./Components/PaymentDrawer/PaymentDrawer";
import Recommendation from "./Components/Recommendation";
import WaitingForPromptsRender from "./Components/WaitingForPromptsRender";
import Modal from "./Components/Modal";
import AutoExpandingTextArea from "./Components/AutoExpandingTextArea.tsx";
import { useClassicRoomSocket } from "./hooks/useClassicRoomSocket";
import { entryRender } from "./Components/entryRender.tsx";

const AI_SHOW_LIMIT = 10;
const AI_BEFORE_ROUND_SHOW_LIMIT = 15;

const DISABLE_AI = false; // Set to true to disable AI functionality

export function NewRoom(props) {
  const [roomInput, setRoomInput] = useState("");
  const [start, setStart] = useState(false);
  const [modal, setModal] = useState(false);

  const [messages, setMessages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [messagesLength, setMessagesLength] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);
  const [highestIndex, setHighestIndex] = useState(0);

  const [isAnimating, setIsAnimating] = useState(false);

  const [openRecommendation, setOpenRecommendation] = useState(false);

  const [waitingForPrompts, setWaitingForPrompts] = useState(false);

  const [isPaymentDrawerOpen, setIsPaymentDrawerOpen] = useState(false);
  const [showPaidPaymentDrawer, setShowPaidPaymentDrawer] = useState(false);
  const [translateYDrawer, setTranslateYDrawer] = useState(0);

  const textArea = useRef(null);

  const [mobileNumber, setMobileNumber] = useState("");

  const { t, i18n } = useTranslation();

  const [numPrompts, setNumPrompts] = useState(0);

  useClassicRoomSocket(
    props.socket,
    props.roomName,
    setNumPrompts,
    setWaitingForPrompts,
  );

  const onChangeMobileInput = (e) => {
    const input = e.currentTarget.value;
    if (/^\d*$/.test(input)) {
      setMobileNumber(input);
    }
  };

  const setCountupValue = () => {
    fetch(props.fetchString + props.roomName, {
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setNumPrompts(data["data"][1].length);
      });
  };

  useEffect(() => {
    setCountupValue();
    const saved = localStorage.getItem("mobileNumber");
    if (saved) {
      setMobileNumber(saved);
    }
  }, []);

  const BLOCKED_REC_INDICES = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16];
  const recs = t("rec", { returnObjects: true }) || [];
  const blockedSuggestions = BLOCKED_REC_INDICES.map((i) => recs[i]?.text).filter(Boolean);

  const add = () => {
    if (roomInput !== "") {
      if (blockedSuggestions.includes(roomInput)) {
        props.showInfoMessage("warning", t("suggestion-incomplete"), false);
        return;
      }
      props.socket.emit("send classic prompt", [props.roomName, roomInput]);
      setRoomInput("");
      props.showInfoMessage("", t("added"), true, "short");
    }
    document.getElementById("page").scrollIntoView();
  };

  const BackButton = () => {
    props.setRoomState("start screen");
    props.socket.emit("leave room", props.roomName);
  };

  const modalButton = () => {
    //Burde legge til at hvis counter er mindre enn lengden, ikke vits å fetche om det er mer i apiet

    fetch(props.fetchString + props.roomName, {
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const newPromptsData = data["data"][1];
        const prompts = newPromptsData.map((prompt) => prompt.value);

        var oldMessages = messages;
        let newMessageLength = 0;

        if (prompts.length > messagesLength) {
          for (let i = messagesLength; i < prompts.length; i++) {
            oldMessages.push(prompts[i]);
          }

          oldMessages = oldMessages
            .slice(0, currentIndex + 2)
            .concat(
              oldMessages
                .slice(currentIndex + 2, prompts.length)
                .sort((a, b) => 0.5 - Math.random()),
            );

          setMessages(oldMessages);
          setMessagesLength(oldMessages.length);
          newMessageLength = oldMessages.length;
        } else {
          newMessageLength = messagesLength;
        }

        if (start === true && currentIndex <= newMessageLength - 2) {
          setModal(true);
        } else {
          BackButton();
        }
      });
  };

  const startRound = () => {
    fetch(props.fetchString + props.roomName, {
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        var promptsData = data["data"][1];

        if (promptsData.length > 0) {
          promptsData = promptsData.sort((a, b) => 0.5 - Math.random());

          const prompts = promptsData.map((prompt) => prompt.value);

          // TODO: we can here add info about ai or not and use it..
          setMessages(prompts);
          setMessagesLength(prompts.length);

          setStart(true);
        } else {
          props.showInfoMessage("warning", t("nothing"), false);
        }
      });
  };

  const next = () => {
    if (!isAnimating) {
      // If first next or we're so far we've every been, and new stuff has to be added to the room
      // this is there bc when people go back and forward again, we don't need to fetch for new entries
      // nr1 to spare network calls
      // nr2 to avoid the order getting switched when going back
      if (
        (highestIndex === 0 || currentIndex === highestIndex + 1) &&
        numPrompts > messagesLength
      ) {
        // if (highestIndex === 0 || currentIndex === highestIndex + 1) {

        fetch(props.fetchString + props.roomName, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            const newPromptsData = data["data"][1];
            const newPrompts = newPromptsData.map((prompt) => prompt.value);
            var oldMessages = messages;

            // If there are new messages to fetch or we're we haven't gone through all already fetched
            if (
              newPrompts.length > messagesLength ||
              messagesLength > currentIndex + 1
            ) {
              // If there are new messages to fetch
              if (newPrompts.length > messagesLength) {
                for (let i = messagesLength; i < newPrompts.length; i++) {
                  oldMessages.push(newPrompts[i]);
                }

                //TODO: use hooks to auto update
                oldMessages = oldMessages
                  .slice(0, currentIndex + 2)
                  .concat(
                    oldMessages
                      .slice(currentIndex + 2, newPrompts.length)
                      .sort((a, b) => 0.5 - Math.random()),
                  );

                setMessages(oldMessages);
                setMessagesLength(oldMessages.length);
              }
              setIsAnimating(true);
              setPreviousIndex(currentIndex);
              setCurrentIndex(currentIndex + 1);

              if (currentIndex > highestIndex) setHighestIndex(currentIndex);

              setTimeout(() => {
                setPreviousIndex(null);
                //setCurrMsg(messages[counter + 1])
                setIsAnimating(false);
              }, 700); // Adjust this value based on your desired animation duration
            } else {
              props.showInfoMessage("warning", t("empty"), false);
            }
          });
      } else {
        if (messagesLength > currentIndex + 1) {
          setIsAnimating(true);
          setPreviousIndex(currentIndex);
          setCurrentIndex(currentIndex + 1);

          if (currentIndex > highestIndex) setHighestIndex(currentIndex);

          setTimeout(() => {
            setPreviousIndex(null);
            //setCurrMsg(messages[counter + 1])
            setIsAnimating(false);
          }, 700); // Adjust this value based on your desired animation duration
        } else {
          props.showInfoMessage("warning", t("empty"), false);
          if (showAiButton) handleOpenDrawerClick();
        }
      }
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      //setCurrMsg(messages[counter - 1])
      setCurrentIndex(currentIndex - 1);
    }
  };

  const showAiButtonBeforeRound =
    !DISABLE_AI && numPrompts > AI_BEFORE_ROUND_SHOW_LIMIT - 1 && !start;

  const showAiButton =
    !DISABLE_AI &&
    numPrompts > AI_SHOW_LIMIT - 1 &&
    numPrompts - currentIndex - 1 < AI_SHOW_LIMIT + 1;

  const divStyle = {
    top: props.containerHeight / 6 - (showAiButton ? 52 : 0),
  };

  // function entryRender() {
  //   return (
  //     <div className="slide-container" style={divStyle}>
  //       {previousIndex !== null && (
  //         <div
  //           className={`${getTextClass(
  //             messages[previousIndex].length
  //           )} slide-text ${isAnimating ? "slide-out" : ""}`}
  //           onAnimationEnd={() => setPreviousIndex(null)}
  //         >
  //           {styleWordInText(messages[previousIndex], wordStyles).map(
  //             (wordElement, index) => (
  //               <React.Fragment key={index}>
  //                 {wordElement}
  //                 {/* Add space if not last word */}
  //                 {index !== messages[previousIndex].split(" ").length - 1 &&
  //                   " "}
  //               </React.Fragment>
  //             )
  //           )}
  //         </div>
  //       )}
  //       <div
  //         className={`${getTextClass(
  //           messages[currentIndex].length
  //         )} slide-text ${isAnimating ? "slide-in" : ""}`}
  //         onAnimationEnd={() => setIsAnimating(false)}
  //       >
  //         {styleWordInText(messages[currentIndex], wordStyles).map(
  //           (wordElement, index) => (
  //             <React.Fragment key={index}>
  //               {wordElement}
  //               {/* Add space if not last word */}
  //               {index !== messages[currentIndex].split(" ").length - 1 && " "}
  //             </React.Fragment>
  //           )
  //         )}
  //       </div>
  //     </div>
  //   );
  // }

  function PromptCounter({ numPrompts }) {
    const className = numPrompts < 100 ? "countdown-l" : "countdown-m";

    return <div className={className}>{numPrompts}</div>;
  }

  // function countdownRender() {
  //   const countdownNumber = numPrompts - currentIndex - 1;
  //   if (countdownNumber < 100)
  //     return <div className="countdown-l">{countdownNumber}</div>;
  //   else return <div className="countdown-m">{countdownNumber}</div>;
  // }

  function prevButtonRender() {
    if (currentIndex > 0) {
      return (
        <div
          className="button-next-prev button-prev text-color-black shadow-black"
          onClick={prev}
        >
          <img className="button-prev-img" src={arrow} alt="" />
        </div>
      );
    } else {
      return (
        <div
          className="button-next-prev button-prev text-color-black shadow-black box-button-center"
          onClick={prev}
          style={{ visibility: "hidden" }}
        >
          <img className="button-prev-img" src={arrow} alt="" />
        </div>
      );
    }
  }

  async function payment() {
    let response;

    try {
      response = await fetch(props.fetchString + "dopayment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          roomName: props.roomName,
          mobileNumber: mobileNumber,
          hasStarted: start,
        }),
      });
    } catch (error) {
      console.log(error);
      //TODO: add to language file
      props.showInfoMessage("warning", "Noe gikk galt", false);
    }

    isRunningRef.current = false;

    // Check if response is OK
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json(); // ✅ Extract JSON from the response
    console.log("Parsed Response:", data);

    if (data.redirectUrl) {
      window.location.href = data.redirectUrl; // ✅ Redirect in the browser
    } else {
      console.error("No redirect URL found.");
    }
  }

  const isRunningRef = useRef(false);

  function startButtonRender() {
    if (start) {
      return <></>;
    } else {
      return (
        <div
          className="button-primary black-fill button-text-l text-color-pink shadow-pink-opaque box-button-center top-margin-s"
          onClick={startRound}
        >
          {t("start")}
        </div>
      );
    }
  }

  function topBarRender() {
    return (
      <div className="container-row lift-topbar">
        <div className="container-row-start">
          <div
            className="button-tertiary-m button-text-m text-color-black"
            onClick={modalButton}
            style={{ maxHeight: "32.5px" }}
          >
            {t("back")}
          </div>
        </div>
        <div className="text-h3 text-color-black left-margin-s text-force-break">
          {props.roomName}
        </div>
      </div>
    );
  }

  function addEntryRender() {
    if (!start) {
      return (
        <div
          className="container"
          style={{ overflow: "auto", paddingRight: 10, paddingBottom: 10 }}
        >
          <AutoExpandingTextArea
            value={roomInput}
            onChange={setRoomInput}
            textareaRef={textArea}
            placeholder={t("write-here")}
            maxLength={280}
          />
          <div
            className="button-primary button-text-l shadow-black text-color-black box-button-center"
            onClick={add}
          >
            {t("add")}
          </div>
        </div>
      );
    } else return <></>;
  }

  function nextButtonRender() {
    return (
      <div
        className="button-next-prev text-color-black shadow-black box-button-center next-button"
        onClick={next}
      >
        {t("next")}
      </div>
    );
  }

  function aiButtonRender() {
    return (
      <div
        className="black-fill button-text-m text-color-pink"
        style={{
          height: "52px",
          cursor: "pointer",
          textAlign: "center",
          lineHeight: "49px",
        }}
        onClick={handleOpenDrawerClick}
      >
        {start ? t("payment.free.cta") : t("classic.addWithAi")}
      </div>
    );
  }

  const handleOpenDrawerClick = () => {
    setIsPaymentDrawerOpen(true);
    setTranslateYDrawer(0); // Reset the translation when opened

    if (!start) {
      setShowPaidPaymentDrawer(true);
    } else {
      fetch(props.fetchString + props.roomName, {
        headers: {
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setShowPaidPaymentDrawer(data["data"][2]);
        });
    }
  };

  function startRoundRender() {
    return (
      <div
        className="App-header"
        style={showAiButton ? { marginBottom: "52px" } : {}}
      >
        {showAiButton ? (
          <div className="ai-banner">{aiButtonRender()}</div>
        ) : (
          <></>
        )}
        {waitingForPrompts && <WaitingForPromptsRender />}
        <PromptCounter numPrompts={numPrompts - currentIndex - 1} />
        {entryRender(
          divStyle,
          previousIndex,
          currentIndex,
          messages,
          isAnimating,
          setPreviousIndex,
          setIsAnimating,
        )}

        <div className="prev-next-buttons gap-20">
          {prevButtonRender()}
          {nextButtonRender()}
        </div>
      </div>
    );
  }

  const renderMainContent = () => (
    <div
      className="App-header"
      style={showAiButtonBeforeRound ? { marginBottom: "52px" } : {}}
    >
      {showAiButtonBeforeRound && (
        <div className="ai-banner">{aiButtonRender()}</div>
      )}
      {waitingForPrompts && <WaitingForPromptsRender />}
      {!start ? preStartRender() : startedRender()}
    </div>
  );

  function preStartRender() {
    return (
      <>
        <PromptCounter numPrompts={numPrompts} />
        <div>
          {topBarRender()}

          {startButtonRender()}
          <Recommendation
            setOpenRecommendation={setOpenRecommendation}
            openRecommendation={openRecommendation}
            setRoomInput={setRoomInput}
            t={t}
            containerHeight={props.containerHeight}
          />
        </div>
        <div style={{ marginRight: -10 }}>{addEntryRender()}</div>
      </>
    );
  }

  function startedRender() {
    return (
      <>
        {topBarRender()}
        {startRoundRender()}
      </>
    );
  }

  return (
    <div className="App-header">
      {modal ? (
        <Modal t={t} BackButton={BackButton} setModal={setModal} />
      ) : (
        renderMainContent()
      )}

      <PaymentDrawer
        isOpen={isPaymentDrawerOpen}
        setIsOpen={setIsPaymentDrawerOpen}
        translateY={translateYDrawer}
        setTranslateY={setTranslateYDrawer}
        mobileNumber={mobileNumber}
        onChangeMobileInput={onChangeMobileInput}
        payment={payment}
        showInfoMessage={props.showInfoMessage}
        showPaidPaymentDrawer={showPaidPaymentDrawer}
        socket={props.socket}
        roomName={props.roomName}
        start={start}
      />
    </div>
  );
}
